import { useListContext } from "react-admin";
import CustomFilterSelect from "./CustomFilterSelect";

const FilterAmountPrincipal = (props: any) => {
  const listContext = useListContext();
  const { filterValues } = listContext;
  const status = props?.status;
  let AmountFilterData;
  if (status == "Paid-Off" || filterValues?.status === "Paid-Off") {
    AmountFilterData = [
      { id: "0", name: "0" },
      { id: ">0", name: "> 0" },
      { id: "<0", name: "< 0" },
    ];
  } else {
    AmountFilterData = [
      { id: "1", name: "<$1000" },
      { id: "2", name: "$1000-$5000" },
      { id: "3", name: "$5000-$10,000" },
      { id: "4", name: "$10,000-$20,000" },
      { id: "5", name: ">$20,000" },
    ];
  }
  return (
    <CustomFilterSelect
      source="activeprincipalbalance"
      label="Remaining Principal Amount"
      choices={AmountFilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterAmountPrincipal;
